module.exports = __webpack_public_path__ + "img/scatter.4880dfef.png";